import { gql } from 'graphql-tag';
export const POSITION_FRAGMENT = `
  fragment PositionFragment on Position {
    ... on PositionTime {
      type
      unit
      value
    }
    ... on PositionEbook {
      type
      location
    }
    ... on PositionCompleted {
      type
    }
  }
`;
export const PROGRESS_DEEP_FRAGMENT = `
  fragment ProgressDeepFragment on Progress {
    uuid
    position {
      ...PositionFragment
    }
    percentage
    contentId
    duration
    createdAt
    updatedAt
  }
  ${POSITION_FRAGMENT}
`;
export const PROGRESS_SHALLOW_FRAGMENT = `
  fragment ProgressShallowFragment on Progress {
    uuid
    contentId
    updatedAt
  }
`;
export const PROGRESS_GET = gql `
  query allProgress($filter: FindProgressArgs) {
    progress: allProgress(
      filter: $filter,
    ) {
      ...ProgressDeepFragment
    }
  }
  ${PROGRESS_DEEP_FRAGMENT}
`;
export const PROGRESS_UPSERT = gql `
  mutation upsertProgress($items: [UpsertProgressDto!]!) {
    result: upsertProgress(items: $items) {
      ...ProgressShallowFragment
    }
  }
  ${PROGRESS_SHALLOW_FRAGMENT}
`;
//# sourceMappingURL=progress.js.map